import * as React from 'react';

import type {EditionStatus} from 'nutshell-graphql-types';
import type {
    GetEditionEngagementStats_edition_engagementStats as EngagementStats,
    GetEditionEngagementStats_edition_comparison,
} from 'nutshell-graphql-types';

import {updateSearchWithNewFilterAndVersion} from '../utils';

import {ComparisonEngagementBlockHeader} from './comparison/comparison-engagement-block-header';
import {ComparisonTestResultsBanner} from './comparison/comparison-test-results-banner';
import {EngagementStatsBlock} from './engagement-stats-block';

import styles from './comparison-engagement-stats.module.css';

type Props = {
    editionStatus: EditionStatus;
    comparison: GetEditionEngagementStats_edition_comparison;
    versionAId: string;
    versionBId: string;
    isLoading: boolean;
    versionAStats: EngagementStats;
    versionBStats: EngagementStats;
};

export function ComparisonEngagementStats(props: Props) {
    const {isLoading, versionAId, versionAStats, versionBStats, comparison} = props;

    return (
        <div className={styles['comparison-engagement-stats']}>
            <EngagementStatsBlock
                isLoading={isLoading}
                stats={comparison.engagementStats}
                includeHelp={true}
                includeBounceRate={true}
                onClickStat={
                    props.editionStatus === 'SENT' || props.editionStatus === 'HALTED'
                        ? (filterKey: string) => {
                              const newSearch = updateSearchWithNewFilterAndVersion(
                                  filterKey,
                                  props.versionAId,
                                  props.versionBId,
                                  location.search,
                                  'both'
                              );

                              return `recipients?${newSearch}`;
                          }
                        : undefined
                }
            />
            <div className={styles['comparison-test-stats']}>
                <ComparisonTestResultsBanner
                    comparison={comparison}
                    versionAId={versionAId}
                    versionAStats={versionAStats}
                    versionBStats={versionBStats}
                    isLoading={isLoading}
                />
                <ComparisonEngagementBlockHeader
                    text='Version A'
                    versionId={props.versionAId}
                    comparison={comparison}
                />
                <div style={{marginLeft: -1, marginRight: -1}}>
                    <EngagementStatsBlock
                        isLoading={isLoading}
                        stats={versionAStats}
                        onClickStat={
                            props.editionStatus === 'SENT' || props.editionStatus === 'HALTED'
                                ? (filterKey: string) => {
                                      const newSearch = updateSearchWithNewFilterAndVersion(
                                          filterKey,
                                          props.versionAId,
                                          props.versionBId,
                                          location.search,
                                          'a'
                                      );

                                      return `recipients?${newSearch}`;
                                  }
                                : undefined
                        }
                    />
                </div>
                <ComparisonEngagementBlockHeader
                    text='Version B'
                    versionId={props.versionBId}
                    comparison={comparison}
                />
                <div style={{marginLeft: -1, marginRight: -1}}>
                    <EngagementStatsBlock
                        isLoading={isLoading}
                        stats={versionBStats}
                        onClickStat={
                            props.editionStatus === 'SENT' || props.editionStatus === 'HALTED'
                                ? (filterKey: string) => {
                                      const newSearch = updateSearchWithNewFilterAndVersion(
                                          filterKey,
                                          props.versionAId,
                                          props.versionBId,
                                          location.search,
                                          'b'
                                      );

                                      return `recipients?${newSearch}`;
                                  }
                                : undefined
                        }
                    />
                </div>
            </div>
        </div>
    );
}
